import { render } from "./Testimonios.vue?vue&type=template&id=9a21c1ac&scoped=true"
import script from "./Testimonios.vue?vue&type=script&lang=js"
export * from "./Testimonios.vue?vue&type=script&lang=js"

import "./Testimonios.vue?vue&type=style&index=0&id=9a21c1ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a21c1ac"]])

export default __exports__